import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import './i18n';
import { initSupabaseAuthTimeout } from './lib/supabaseTimeout';

// CRITICAL: Initialize timeout wrappers for Supabase auth methods
// This prevents hanging when navigating away and returning to the tab
initSupabaseAuthTimeout();

createRoot(document.getElementById('root')!).render(<App />);